import { cn } from "@/lib/utils";

type TLegalDocumentStatusBadgeProps = {
  isActive: boolean;
  className?: string;
};

export function LegalDocumentStatusBadge({ isActive, className }: TLegalDocumentStatusBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium",
        isActive ? "bg-primary/10 text-primary" : "bg-muted text-muted-foreground",
        className
      )}
    >
      {isActive ? "Active" : "Draft"}
    </span>
  );
}
